<ng-container *transloco="let translate">
	@if (
		{
			collapsed: sidenavService.collapsed$ | async,
			user: user$ | async,
			nextTheme: nextTheme$ | async,
			currentTheme: currentTheme$ | async,
		};
		as vm
	) {
		@if (!vm.collapsed && vm.user?._raw.plan === UserStatus.TRIAL && !isNativePlatform) {
			<div class="fl fl-ai-fs fl-dir-c br-2 fl-gap-0h p-1 bg-imp-8-20 m-1-rl">
				<div
					class="fl fl-gap-1 fl-ai-c p-1-l p-0h-tb p-2-r br-50 fc-800-as-bg"
					style="border-radius: 50px"
				>
					<span class="w-sp-2 h-sp-2">✨</span>
					<span class="fc-inverse fs-sp-1h line-height-1">
						{{ translate('home.account_deletion_warning.title') }}
					</span>
				</div>
				<div class="fl fl-ai-fs fl-gap-1 p-1 fl-dir-c w-100">
					<span class="fs-sp-2q">
						{{
							translate('home.account_deletion_warning.trial_ending', {
								days: $daysUntilTrialExpires(),
							})
						}}
					</span>
					<progress-line
						class="w-100"
						style="height: calc(0.5 * var(--spacing)); display: var(--display-progress)"
						[value]="($daysSinceTrialStarted() / $trialTotalDays()) * 100"
					></progress-line>
					<span class="fs-sp-1h fc-800" style="opacity: 0.6">
						{{
							translate('home.account_deletion_warning.time_period', {
								days:
									$daysSinceTrialStarted() > $trialTotalDays()
										? $trialTotalDays()
										: $daysSinceTrialStarted(),
								finishDate: $trialTotalDays(),
							})
						}}
					</span>
				</div>
				<a
					href="https://myreach.io/pricing"
					target="_blank"
					class="fl fl-ai-c p-1-l p-0h-r w-100 fl-gap-1"
				>
					<span class="fl-adaptable fs-sp-1t fc-800">
						{{ translate('home.account_deletion_warning.plans') }}
					</span>
					<i class="icon-arrow arrow-right fl-fixed fs-sp-2t"></i>
				</a>
			</div>
		}

		<button
			#anchor
			class="profile-menu-button fl fl-dir-r fl-ai-c p-1-tb bg-standard-hover-on-hover br-1 w-100"
			[class.bg-standard-hover-on-hover]="!vm.collapsed"
			[class.p-0h-rl]="!vm.collapsed"
			[class.p-0-rl]="vm.collapsed"
			[class.fl-jc-between]="!vm.collapsed"
			[class.fl-jc-c]="vm.collapsed"
			(click)="vm.collapsed ? navigateToProfileSettings() : menu?.open(anchor)"
		>
			<div class="fl fl-dir-r fl-ai-c fl-gap-1q" [class.fl-adaptable]="!vm.collapsed">
				<a
					[routerLink]="['/', 'home', 'profile']"
					style="cursor: pointer"
					[tooltip]="translate('general.profile')"
					(click)="$event.preventDefault(); $event.stopPropagation()"
					class="profile-link"
				>
					<reach-user-thumbnail
						class="w-100 h-100 user-thumbnail"
						[user]="$any(vm.user)"
					></reach-user-thumbnail>
				</a>
				@if (!vm.collapsed) {
					<div class="fl fl-dir-c fl-fixed">
						<span class="fs-body1">{{ vm.user?.fullName }}</span>
						<span class="fs-small2 fc-400">{{ vm.user?.email }}</span>
					</div>
				}
				<!-- Uncomment when plans done -->
				<!-- <div
					*ngIf="!vm.collapsed"
					class="m-1-l br-1 plan p-0h-tb fc-400 fs-xs"
					style="padding-left: 6px; padding-right: 6px;"
					>
					Free Plan
				</div> -->
			</div>
			@if (!vm.collapsed) {
				<div class="fl fl-dir-r fl-ai-c">
					<!-- Uncomment when notifications are done -->
					<!-- <a uiNewButtonIcon>
						<i class="icon-notifications"></i>
					</a> -->
					<i
						class="icon-chevron fc-400"
						[class.chevron-down]="$menuStatus()"
						[class.chevron-up]="!$menuStatus()"
					></i>
				</div>
			}
		</button>

		<ng-template integrationPrimaryBtn #errorTpl>
			{{ 'general.errors.unknown' | transloco }}
		</ng-template>

		<reach-menu
			#menu
			[activeSection]="'1'"
			(opened)="toggleMenuSettings()"
			(closed)="toggleMenuSettings()"
		>
			<ng-container
				*reachMenuSection="
					'1';
					desktopType: MenuDesktopType.FLOATING;
					anchor: anchor;
					widthSize: WidthSize.PX240;
					lightBg: true;
					showFooter: true;
					bordered: true;
					forcePosition: 'TOP'
				"
			>
				<div class="fl fl-adaptable fl-dir-c fl-gap-0h fl-ai-fs w-100">
					<a
						class="fs-body1 w-100 p-1-rl p-0t-tb br-0t bg-standard-hover-on-hover fl fl-gap-1 fl-ai-c fc-800"
						style="transition: background-color 0.2s ease-in-out"
						href="https://handbook.rea.ch/"
						(click)="menu?.close()"
						target="_blank"
					>
						<i class="fs-sp-2 fc-400 icon-handbook"></i>
						<span class="fl-adaptable">Handbook</span>
						<i class="icon-arrow-diagonal fs-sp-2 fc-400"></i>
					</a>

					@if (showBrowserExtension) {
						<button
							class="fs-body1 w-100 p-1-rl p-0t-tb br-0t bg-standard-hover-on-hover fl fl-gap-1 fl-ai-c fc-800"
							style="transition: background-color 0.2s ease-in-out"
							(click)="openExtensionPage(); menu?.close()"
						>
							<i class="fs-sp-2 fc-400 icon-puzzle-outline"></i>
							<span class="fl-adaptable">Browser extension</span>
							<i class="icon-arrow-diagonal fs-sp-2 fc-400"></i>
						</button>
					}

					<div class="separator"></div>

					<div
						class="w-100 p-1-l p-0h-r p-0q-tb fl fl-gap-0q fl-ai-c fs-m fc-800 pos-rel"
					>
						<div class="fl fl-ai-c fl-adaptable fl-gap-1 fs-body1">
							<i class="fs-sp-2 fc-400 icon-palette"></i>
							Theme
						</div>
						<div
							class="pos-abs pos-r-0 fl-fixed fl fl-ai-c fl-gap-0q bg-270 br-1q p-0q theme-switcher"
						>
							<span
								class="theme-switcher-pill br-1 bg-180 border-230"
								style="border-width: 0.5px"
								[style.transform]="getThemePillTransform()"
							></span>
							@for (theme of allThemes; track $index) {
								<button
									class="theme-switcher-option hover-parent fl-fixed p-0h-tb p-1-rl br-1q fl fl-ai-c fl-jc-c bg-standard-hover-on-hover"
									[class.bg-standard-hover-on-hover]="
										theme !== vm.currentTheme?.theme
									"
									[tooltip]="themeMap[theme].tooltipKey | transloco"
									(click)="setTheme(theme)"
								>
									<i
										class="fs-sp-2 fc-800-on-hover-parent"
										[class.fc-500]="theme !== vm.currentTheme?.theme"
										[class]="themeMap[theme].icon"
									></i>
								</button>
							}
						</div>
					</div>

					<button
						class="fs-body1 w-100 p-1-rl p-0t-tb br-0t bg-standard-hover-on-hover fl fl-gap-1 fl-ai-c fc-800"
						style="transition: background-color 0.2s ease-in-out"
						(click)="navigateToProfileSettings(); menu?.close()"
					>
						<i class="fs-sp-2 fc-400 icon-settings"></i>
						Settings
					</button>

					<div class="separator"></div>

					<button
						class="fs-body1 w-100 p-1-rl p-0t-tb br-0t bg-warn-500-10-on-hover fl fl-gap-1 fl-ai-c fc-800 hover-parent fc-warn-on-hover"
						style="
							transition:
								background-color 0.2s ease-in-out,
								color 0.2s ease-in-out;
						"
						(click)="signOut(); menu?.close()"
					>
						<i class="fs-sp-2 fc-warn-on-hover-parent fc-400 icon-log-out"></i>
						Sign out
					</button>
				</div>
			</ng-container>
		</reach-menu>
	}
</ng-container>
